import { CarOutlined, EyeInvisibleOutlined, EyeOutlined, FileExcelOutlined, FilePdfOutlined, SyncOutlined, PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { PageHeader, Row, Col, Card, Statistic, message, Select, Tag, Popconfirm } from "antd";
import { ResponsiveLine } from "@nivo/line";
import { ResponsiveBar } from "@nivo/bar";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/es";
import * as XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  TableItem,
  ButtonItem,
  dineroDisabledMask,
} from "../../../../Components/Items";
import RangePickerItem from "../../../../Components/RangePickerItem";
import SelectItem from "../../../../Components/SelectItem";
import SubHeaderItem from "../../../../Components/SubHeaderItem";
import TabbedDynamicTable from "../../../../Components/TabbedDynamicTable";
import reporteConsumoCombustiblePdf from "../../../../Pdf/reporteConsumoCombustiblePdf";
import ModalCargaCombustible from "./ModalCargaCombustible";
import MandarCorreoCargaCombustible from "./MandarCorreoCargaCombustible";
import ModalReportesCargas from "./ModalReportesCargas";
import {
  computarRendimientoPorCamion,
  resumenPorChofer as resumenPorChoferUtil,
} from "./cargasCombustible.utils";

moment.locale("es");

class ConsumoCombustible extends Component {
  state = {
    loading: false,
    loadingInsumos: false,
    loadingVehiculos: false,
    fechas: [moment().startOf("month"), moment().endOf("day")],
    insumoId: undefined,
    insumoNombre: "",
    todosInsumos: [],
    empresa: null,
    dataGraficoGasto: [],
    dataGraficoKm: [],
    dataRendimiento: [],
    avgRendimiento: 0,
    vehiculoId: this.props.location?.state?.id || undefined,
    vehiculoNombre: this.props.location?.state?.nombre || "",
    vehiculoSeleccionado: null,
    todosVehiculos: [],
    ventas: [],
    facturas: [],
    selectedVentasKeys: [],
    selectedFacturasKeys: [],
    mostrarGraficas: true,
    // Modo manual (cargas) 
    modo: "manual",
    cargas: [],
    loadingCargas: false,
    modalCarga: false,
    cargaEditando: null,
    modalCorreoCarga: false,
    cargaCorreo: null,
    modalReportes: false,
  };

  componentDidMount() {
    this.cargarInsumos();
    this.cargarVehiculos();
    // Modo manual es el predeterminado: si ya hay vehículo, cargar sus cargas
    if (this.state.vehiculoId) {
      this.cargarCargas();
    }
  }

  cargarVehiculos() {
    this.setState({ loadingVehiculos: true });
    axios
      .post(
        "proyectos/selectTodosProyectos",
        { empresaId: this.props.empresaId, valor: 1, vehiculos: true },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loadingVehiculos: false });
        if (Array.isArray(res.data)) {
          const currentId = this.state.vehiculoId;
          const vehiculoSeleccionado = currentId
            ? res.data.find((v) => v._id.toString() === currentId.toString()) || null
            : null;
          this.setState({ todosVehiculos: res.data, vehiculoSeleccionado });
        }
      });
  }

  cargarInsumos() {
    this.setState({ loadingInsumos: true });
    axios
      .post(
        "insumos/selectInsumosCompra",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loadingInsumos: false });
        if (Array.isArray(res.data)) {
          this.setState({ todosInsumos: res.data });
        }
      });
  }

  consultarRendimiento() {
    const { fechas, insumoId, vehiculoId } = this.state;
    if (!vehiculoId) {
      return message.warning("Selecciona un vehículo");
    }
    if (!fechas || !fechas[0] || !fechas[1]) {
      return message.warning("Selecciona un período de fechas");
    }
    if (!insumoId) {
      return message.warning("Selecciona el insumo de combustible");
    }

    this.setState({ loading: true });
    axios
      .post(
        "rendimientos/selectRendimientoCombustible",
        {
          empresaId: this.props.empresaId,
          proyectoId: vehiculoId,
          fechaInicio: fechas[0].toISOString(),
          fechaFin: fechas[1].toISOString(),
          insumoId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data && res.data.ventas !== undefined) {
          const allVentaKeys = res.data.ventas.map((v) => v.rowKey);
          const allFacturaKeys = res.data.facturas.map((f) => f._id.toString());

          // Agrupar facturas por fecha para gráfica de gasto
          const gastoMap = {};
          res.data.facturas.forEach((f) => {
            const key = moment(f.fechaFactura).format("DD/MM/YYYY");
            gastoMap[key] = (gastoMap[key] || 0) + (f.totalPagar || 0);
          });
          const dataGraficoGasto = [
            {
              id: "Gasto Combustible",
              color: "#fa8c16",
              data: Object.entries(gastoMap)
                .sort((a, b) => moment(a[0], "DD/MM/YYYY").valueOf() - moment(b[0], "DD/MM/YYYY").valueOf())
                .map(([x, y]) => ({ x, y })),
            },
          ];

          // Agrupar ventas por fecha para gráfica de km
          const kmMap = {};
          res.data.ventas.forEach((v) => {
            const key = moment(v.fechaVenta).format("DD/MM/YYYY");
            kmMap[key] = (kmMap[key] || 0) + (v.kmRecorridos || 0);
          });
          const dataGraficoKm = [
            {
              id: "KM Recorridos",
              color: "#1890ff",
              data: Object.entries(kmMap)
                .sort((a, b) => moment(a[0], "DD/MM/YYYY").valueOf() - moment(b[0], "DD/MM/YYYY").valueOf())
                .map(([x, y]) => ({ x, y })),
            },
          ];

          // Calcular rendimiento (km/L) por evento de carga
          const facturasOrdenadas = [...res.data.facturas].sort(
            (a, b) => moment(a.fechaFactura).valueOf() - moment(b.fechaFactura).valueOf()
          );
          const ventasOrdenadas = [...res.data.ventas].sort(
            (a, b) => moment(a.fechaVenta).valueOf() - moment(b.fechaVenta).valueOf()
          );
          let lastFuelDate = null;
          const rendimientoRaw = [];
          facturasOrdenadas.forEach((f) => {
            const fuelDate = moment(f.fechaFactura);
            const liters = f.combustibleCantidad || 0;
            if (liters === 0) return;
            const kmEnPeriodo = ventasOrdenadas
              .filter((v) => {
                const vd = moment(v.fechaVenta);
                return (!lastFuelDate || vd.isAfter(lastFuelDate)) && !vd.isAfter(fuelDate);
              })
              .reduce((s, v) => s + (v.kmRecorridos || 0), 0);
            rendimientoRaw.push({
              fecha: fuelDate.format("DD/MM"),
              rendimiento: liters > 0 ? +(kmEnPeriodo / liters).toFixed(3) : 0,
              kmEnPeriodo,
              liters,
            });
            lastFuelDate = fuelDate;
          });
          const avgRend =
            rendimientoRaw.length > 0
              ? rendimientoRaw.reduce((s, r) => s + r.rendimiento, 0) / rendimientoRaw.length
              : 0;
          const dataRendimiento = rendimientoRaw.map((r) => ({
            ...r,
            color: r.rendimiento >= avgRend ? "#1890ff" : "#f5222d",
          }));

          this.setState({
            ventas: res.data.ventas,
            facturas: res.data.facturas,
            empresa: res.data.empresa || null,
            selectedVentasKeys: allVentaKeys,
            selectedFacturasKeys: allFacturaKeys,
            dataGraficoGasto,
            dataGraficoKm,
            dataRendimiento,
            avgRendimiento: avgRend,
          });
          if (res.data.ventas.length === 0 && res.data.facturas.length === 0) {
            message.info("No se encontraron datos en el período seleccionado");
          }
        } else {
          message.error("Error al consultar los datos");
        }
      });
  }

  calcularStats() {
    const { ventas, facturas, selectedVentasKeys, selectedFacturasKeys } =
      this.state;
    const ventasSel = ventas.filter((v) =>
      selectedVentasKeys.includes(v.rowKey)
    );
    const facturasSel = facturas.filter((f) =>
      selectedFacturasKeys.includes(f._id.toString())
    );
    const totalKm = ventasSel.reduce((s, v) => s + (v.kmRecorridos || 0), 0);
    const totalLitros = facturasSel.reduce(
      (s, f) => s + (f.combustibleCantidad || 0),
      0
    );
    const gastoTotal = facturasSel.reduce(
      (s, f) => s + (f.totalPagar || 0),
      0
    );
    const kmPorLitro = totalLitros > 0 ? totalKm / totalLitros : 0;
    const costoPorKm = totalKm > 0 ? gastoTotal / totalKm : 0;
    return { totalKm, totalLitros, gastoTotal, kmPorLitro, costoPorKm };
  }

  recalcularGraficas() {
    const { ventas, facturas, selectedVentasKeys, selectedFacturasKeys } = this.state;
    const ventasSel = ventas.filter((v) => selectedVentasKeys.includes(v.rowKey));
    const facturasSel = facturas.filter((f) => selectedFacturasKeys.includes(f._id.toString()));

    const gastoMap = {};
    facturasSel.forEach((f) => {
      const key = moment(f.fechaFactura).format("DD/MM/YYYY");
      gastoMap[key] = (gastoMap[key] || 0) + (f.totalPagar || 0);
    });
    const dataGraficoGasto = [
      {
        id: "Gasto Combustible",
        color: "#fa8c16",
        data: Object.entries(gastoMap)
          .sort((a, b) => moment(a[0], "DD/MM/YYYY").valueOf() - moment(b[0], "DD/MM/YYYY").valueOf())
          .map(([x, y]) => ({ x, y })),
      },
    ];

    const kmMap = {};
    ventasSel.forEach((v) => {
      const key = moment(v.fechaVenta).format("DD/MM/YYYY");
      kmMap[key] = (kmMap[key] || 0) + (v.kmRecorridos || 0);
    });
    const dataGraficoKm = [
      {
        id: "KM Recorridos",
        color: "#1890ff",
        data: Object.entries(kmMap)
          .sort((a, b) => moment(a[0], "DD/MM/YYYY").valueOf() - moment(b[0], "DD/MM/YYYY").valueOf())
          .map(([x, y]) => ({ x, y })),
      },
    ];

    const facturasOrdenadas = [...facturasSel].sort(
      (a, b) => moment(a.fechaFactura).valueOf() - moment(b.fechaFactura).valueOf()
    );
    const ventasOrdenadas = [...ventasSel].sort(
      (a, b) => moment(a.fechaVenta).valueOf() - moment(b.fechaVenta).valueOf()
    );
    let lastFuelDate = null;
    const rendimientoRaw = [];
    facturasOrdenadas.forEach((f) => {
      const fuelDate = moment(f.fechaFactura);
      const liters = f.combustibleCantidad || 0;
      if (liters === 0) return;
      const kmEnPeriodo = ventasOrdenadas
        .filter((v) => {
          const vd = moment(v.fechaVenta);
          return (!lastFuelDate || vd.isAfter(lastFuelDate)) && !vd.isAfter(fuelDate);
        })
        .reduce((s, v) => s + (v.kmRecorridos || 0), 0);
      rendimientoRaw.push({
        fecha: fuelDate.format("DD/MM"),
        rendimiento: liters > 0 ? +(kmEnPeriodo / liters).toFixed(3) : 0,
        kmEnPeriodo,
        liters,
      });
      lastFuelDate = fuelDate;
    });
    const avgRend =
      rendimientoRaw.length > 0
        ? rendimientoRaw.reduce((s, r) => s + r.rendimiento, 0) / rendimientoRaw.length
        : 0;
    const dataRendimiento = rendimientoRaw.map((r) => ({
      ...r,
      color: r.rendimiento >= avgRend ? "#1890ff" : "#f5222d",
    }));

    this.setState({ dataGraficoGasto, dataGraficoKm, dataRendimiento, avgRendimiento: avgRend });
    message.success("Gráficas actualizadas con la selección actual");
  }

  descargarExcel() {
    const vehiculoNombre = this.state.vehiculoNombre || "Vehiculo";
    const { ventas, facturas, selectedVentasKeys, selectedFacturasKeys } =
      this.state;
    const ventasSel = ventas.filter((v) =>
      selectedVentasKeys.includes(v.rowKey)
    );
    const facturasSel = facturas.filter((f) =>
      selectedFacturasKeys.includes(f._id.toString())
    );
    const stats = this.calcularStats();

    const datosViajes = ventasSel.map((v) => ({
      Fecha: moment(v.fechaVenta).format("DD/MM/YYYY"),
      Documento:
        v.facturaSerie && v.facturaNumero
          ? `${v.facturaSerie}-${v.facturaNumero}`
          : v.remisionSerie && v.remisionNumero
          ? `${v.remisionSerie}-${v.remisionNumero}`
          : "S/N",
      Cliente: v.cliente || "",
      Origen: v.origenDireccion || "",
      Destino: v.destinoDireccion || "",
      "KM Recorridos": v.kmRecorridos || 0,
      "Total Venta": v.totalPagar || 0,
    }));

    const datosCombustible = facturasSel.map((f) => ({
      Fecha: moment(f.fechaFactura).format("DD/MM/YYYY"),
      "# Factura": f.numeroFactura || "",
      Código: f.codigoFactura || "",
      Proveedor: f.proveedor || "",
      Litros: f.combustibleCantidad || 0,
      "Precio / Litro": f.combustiblePrecioUnitario || 0,
      "Subtotal Combustible": f.combustibleSubtotal || 0,
      "Total Factura": f.totalPagar || 0,
    }));

    const datosResumen = [
      { Concepto: "KM / Litro", Valor: stats.kmPorLitro.toFixed(3) },
      { Concepto: "Costo por KM", Valor: `$${stats.costoPorKm.toFixed(2)}` },
      { Concepto: "Total Litros", Valor: stats.totalLitros.toFixed(3) },
      {
        Concepto: "Gasto Total Combustible",
        Valor: `$${stats.gastoTotal.toFixed(2)}`,
      },
      { Concepto: "Total KM Recorridos", Valor: stats.totalKm.toFixed(2) },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(datosViajes),
      "Viajes (KM)"
    );
    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(datosCombustible),
      "Combustible"
    );
    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(datosResumen),
      "Resumen"
    );
    XLSX.writeFile(
      wb,
      `Consumo_${vehiculoNombre}_${moment().format("YYYY-MM-DD")}.xlsx`
    );
  }

  descargarPdf() {
    const vehiculoNombre = this.state.vehiculoNombre || "Vehículo";
    const { ventas, facturas, selectedVentasKeys, selectedFacturasKeys, fechas, insumoNombre, empresa, vehiculoSeleccionado } =
      this.state;
    const ventasSel = ventas.filter((v) =>
      selectedVentasKeys.includes(v.rowKey)
    );
    const facturasSel = facturas.filter((f) =>
      selectedFacturasKeys.includes(f._id.toString())
    );
    const stats = this.calcularStats();

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake
      .createPdf(
        reporteConsumoCombustiblePdf({
          empresa,
          vehiculoNombre,
          vehiculoInfo: vehiculoSeleccionado,
          insumoNombre,
          fechaInicio: fechas[0],
          fechaFin: fechas[1],
          ventas: ventasSel,
          facturas: facturasSel,
          stats,
        })
      )
      .download(`Consumo_${vehiculoNombre}_${moment().format("YYYY-MM-DD")}`);
  }


  cargarCargas() {
    const { vehiculoId, fechas } = this.state;
    if (!vehiculoId) {
      return message.warning("Selecciona un vehículo");
    }
    this.setState({ loadingCargas: true });
    axios
      .post(
        "rendimientos/selectCargasCombustible",
        {
          empresaId: this.props.empresaId,
          proyectoId: vehiculoId,
          fechaInicio: fechas && fechas[0] ? fechas[0].toISOString() : undefined,
          fechaFin: fechas && fechas[1] ? fechas[1].toISOString() : undefined,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loadingCargas: false });
        if (res.data && Array.isArray(res.data.cargas)) {
          this.setState({
            cargas: res.data.cargas,
            empresa: res.data.empresa || this.state.empresa,
          });
          if (res.data.cargas.length === 0) {
            message.info("No hay cargas registradas para este vehículo en el período");
          }
        } else {
          message.error("Error al consultar las cargas");
        }
      })
      .catch(() => {
        this.setState({ loadingCargas: false });
        message.error("Error al consultar las cargas");
      });
  }

  calcularCargasComputadas() {
    return computarRendimientoPorCamion(this.state.cargas);
  }

  calcularStatsCargas(computadas) {
    const cargas = computadas || this.calcularCargasComputadas();
    const totalLitros = cargas.reduce((s, c) => s + (c.litros || 0), 0);
    const gastoTotal = cargas.reduce((s, c) => s + (c.total || 0), 0);
    const kms = cargas.map((c) => c.kmOdometro || 0);
    const totalKm = kms.length > 1 ? Math.max(...kms) - Math.min(...kms) : 0;
    const litrosConTramo = cargas
      .filter((c) => c.rendimiento != null)
      .reduce((s, c) => s + (c.litros || 0), 0);
    const kmPorLitro = litrosConTramo > 0 ? totalKm / litrosConTramo : 0;
    const costoPorKm = totalKm > 0 ? gastoTotal / totalKm : 0;
    const rends = cargas.filter((c) => c.rendimiento != null).map((c) => c.rendimiento);
    const avgRendimiento = rends.length > 0 ? rends.reduce((a, b) => a + b, 0) / rends.length : 0;
    return { totalLitros, gastoTotal, totalKm, kmPorLitro, costoPorKm, avgRendimiento };
  }

  abrirModalCarga(carga) {
    if (!this.state.vehiculoId) {
      return message.warning("Selecciona un vehículo primero");
    }
    this.setState({ modalCarga: true, cargaEditando: carga || null });
  }

  cerrarModalCarga(didSave) {
    this.setState({ modalCarga: false, cargaEditando: null });
    if (didSave) this.cargarCargas();
  }

  eliminarCarga(cargaId) {
    axios
      .post(
        "rendimientos/eliminarCargaCombustible",
        { empresaId: this.props.empresaId, cargaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data && res.data.success === 2) {
          message.success("Carga eliminada");
          this.cargarCargas();
        } else {
          message.error(res.data?.message || "No se pudo eliminar la carga");
        }
      });
  }

  abrirCorreoCarga(cargaComputada) {
    this.setState({ modalCorreoCarga: true, cargaCorreo: cargaComputada });
  }

  render() {
    const { vehiculoNombre, vehiculoId, modo } = this.state;
    const stats = this.calcularStats();
    const hayDatos =
      this.state.ventas.length > 0 || this.state.facturas.length > 0;

    const cargasComputadas = this.calcularCargasComputadas();
    const statsCargas = this.calcularStatsCargas(cargasComputadas);
    const hayCargas = cargasComputadas.length > 0;
    const dataRendimientoCargas = cargasComputadas
      .filter((c) => c.rendimiento != null)
      .map((c) => ({
        fecha: `${(c.kmOdometro || 0).toLocaleString("es-MX")}`,
        rendimiento: +c.rendimiento.toFixed(3),
        liters: c.litros,
        kmEnPeriodo: c.kmRecorridos,
        color: c.rendimiento >= statsCargas.avgRendimiento ? "#1890ff" : "#f5222d",
      }));

    const columnsVentas = [
      {
        title: "Fecha",
        dataIndex: "fechaVenta",
        key: "fechaVenta",
        width: "10%",
        sorter: (a, b) =>
          moment(a.fechaVenta).valueOf() - moment(b.fechaVenta).valueOf(),
        render: (v) => (v ? moment(v).format("DD/MM/YYYY") : "-"),
      },
      {
        title: "Documento",
        key: "doc",
        width: "10%",
        render: (_, r) =>
          r.facturaSerie && r.facturaNumero
            ? `${r.facturaSerie}-${r.facturaNumero}`
            : r.remisionSerie && r.remisionNumero
            ? `${r.remisionSerie}-${r.remisionNumero}`
            : "S/N",
      },
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        buscar: "cliente",
        ellipsis: true,
      },
      {
        title: "Origen",
        dataIndex: "origenDireccion",
        key: "origenDireccion",
        ellipsis: true,
      },
      {
        title: "Destino",
        dataIndex: "destinoDireccion",
        key: "destinoDireccion",
        ellipsis: true,
      },
      {
        title: "KM Recorridos",
        dataIndex: "kmRecorridos",
        key: "kmRecorridos",
        align: "right",
        width: "12%",
        sorter: (a, b) => (a.kmRecorridos || 0) - (b.kmRecorridos || 0),
        render: (v) => (v || 0).toFixed(2),
      },
      {
        title: "Total Venta",
        dataIndex: "totalPagar",
        key: "totalPagar",
        align: "right",
        width: "12%",
        sorter: (a, b) => (a.totalPagar || 0) - (b.totalPagar || 0),
        render: (v) => dineroDisabledMask(v),
      },
    ];

    const columnsFacturas = [
      {
        title: "Fecha",
        dataIndex: "fechaFactura",
        key: "fechaFactura",
        width: "10%",
        sorter: (a, b) =>
          moment(a.fechaFactura).valueOf() - moment(b.fechaFactura).valueOf(),
        render: (v) => (v ? moment(v).format("DD/MM/YYYY") : "-"),
      },
      {
        title: "# Factura",
        dataIndex: "numeroFactura",
        key: "numeroFactura",
        width: "8%",
      },
      {
        title: "Código",
        dataIndex: "codigoFactura",
        key: "codigoFactura",
        width: "10%",
        buscar: "codigoFactura",
      },
      {
        title: "Proveedor",
        dataIndex: "proveedor",
        key: "proveedor",
        buscar: "proveedor",
        ellipsis: true,
      },
      {
        title: "Litros",
        dataIndex: "combustibleCantidad",
        key: "combustibleCantidad",
        align: "right",
        width: "9%",
        sorter: (a, b) =>
          (a.combustibleCantidad || 0) - (b.combustibleCantidad || 0),
        render: (v) => (v || 0).toFixed(3),
      },
      {
        title: "Precio / L",
        dataIndex: "combustiblePrecioUnitario",
        key: "combustiblePrecioUnitario",
        align: "right",
        width: "10%",
        render: (v) => dineroDisabledMask(v),
      },
      {
        title: "Subtotal Comb.",
        dataIndex: "combustibleSubtotal",
        key: "combustibleSubtotal",
        align: "right",
        width: "12%",
        render: (v) => dineroDisabledMask(v),
      },
      {
        title: "Total Factura",
        dataIndex: "totalPagar",
        key: "totalPagar",
        align: "right",
        width: "12%",
        sorter: (a, b) => (a.totalPagar || 0) - (b.totalPagar || 0),
        render: (v) => dineroDisabledMask(v),
      },
    ];

    const columnsCargas = [
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        width: "10%",
        render: (v) => (v ? moment(v).format("DD/MM/YYYY") : "-"),
      },
      {
        title: "KM Odómetro",
        dataIndex: "kmOdometro",
        key: "kmOdometro",
        align: "right",
        width: "11%",
        render: (v) => (v || 0).toLocaleString("es-MX"),
      },
      {
        title: "Litros",
        dataIndex: "litros",
        key: "litros",
        align: "right",
        width: "8%",
        render: (v) => (v || 0).toFixed(3),
      },
      {
        title: "Tipo",
        dataIndex: "tipoCombustible",
        key: "tipoCombustible",
        width: "8%",
        render: (v) =>
          v ? (
            <Tag color={v === "diesel" ? "#595959" : "#fa8c16"} style={{ margin: 0 }}>
              {v.charAt(0).toUpperCase() + v.slice(1)}
            </Tag>
          ) : (
            "-"
          ),
      },
      {
        title: "Chofer",
        dataIndex: "choferNombre",
        key: "choferNombre",
        width: "13%",
        ellipsis: true,
        render: (v) => v || "—",
      },
      {
        title: "Precio / L",
        dataIndex: "precioPorLitro",
        key: "precioPorLitro",
        align: "right",
        width: "9%",
        render: (v) => dineroDisabledMask(v),
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        align: "right",
        width: "10%",
        render: (v) => dineroDisabledMask(v),
      },
      {
        title: "KM Recorridos",
        dataIndex: "kmRecorridos",
        key: "kmRecorridos",
        align: "right",
        width: "11%",
        render: (v) => (v != null ? v.toFixed(2) : "—"),
      },
      {
        title: "Rendimiento",
        dataIndex: "rendimiento",
        key: "rendimiento",
        align: "right",
        width: "11%",
        render: (v) =>
          v != null ? (
            <span style={{ fontWeight: 600, color: v >= statsCargas.avgRendimiento ? "#1890ff" : "#f5222d" }}>
              {v.toFixed(3)} km/L
            </span>
          ) : (
            "—"
          ),
      },
      {
        title: "Acciones",
        key: "acciones",
        width: "11%",
        render: (_, r) => (
          <div style={{ display: "flex", gap: 4 }}>
            {this.props.permisoEditarCarga && (
              <ButtonItem
                size="small"
                icon={<EditOutlined />}
                onClick={() => this.abrirModalCarga(r)}
              />
            )}
            <ButtonItem
              size="small"
              naranja
              icon={<FilePdfOutlined />}
              onClick={() => this.abrirCorreoCarga(r)}
            />
            {this.props.permisoEliminarCarga && (
              <Popconfirm
                title="¿Eliminar esta carga?"
                onConfirm={() => this.eliminarCarga(r._id)}
                okText="Sí"
                cancelText="No"
              >
                <ButtonItem size="small" rojo icon={<DeleteOutlined />} />
              </Popconfirm>
            )}
          </div>
        ),
      },
    ];

    const statCards = [
      { title: "KM / Litro", value: statsCargas.kmPorLitro.toFixed(3), suffix: "km/L", color: "#1890ff" },
      { title: "Costo por KM", value: `$${statsCargas.costoPorKm.toFixed(2)}`, suffix: "/km", color: "#52c41a" },
      { title: "Total Litros", value: statsCargas.totalLitros.toFixed(3), suffix: "L", color: "#fa8c16" },
      { title: "Gasto Total", value: dineroDisabledMask(statsCargas.gastoTotal), suffix: "", color: "#f5222d" },
      { title: "Total KM", value: statsCargas.totalKm.toFixed(2), suffix: "km", color: "#722ed1" },
    ];

    return (
      <>
        <PageHeader
          title={`Consumo de Combustible — ${vehiculoNombre}`}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 0,
          }}
          onBack={() => this.props.history.goBack()}
          extra={
            modo === "automatico" && hayDatos ? (
              <>
                <ButtonItem
                  icon={this.state.mostrarGraficas ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                  onClick={() => this.setState((s) => ({ mostrarGraficas: !s.mostrarGraficas }))}
                  lila
                >
                  {this.state.mostrarGraficas ? "Ocultar Gráficas" : "Mostrar Gráficas"}
                </ButtonItem>
                <ButtonItem
                  icon={<SyncOutlined />}
                  onClick={this.recalcularGraficas.bind(this)}
                >
                  Refrescar Gráficas
                </ButtonItem>
                <ButtonItem
                  verde
                  icon={<FileExcelOutlined />}
                  onClick={this.descargarExcel.bind(this)}
                >
                  Excel
                </ButtonItem>
                <ButtonItem
                  rojo
                  icon={<FilePdfOutlined />}
                  onClick={this.descargarPdf.bind(this)}
                >
                  PDF
                </ButtonItem>
              </>
            ) : null
          }
        />

        {/* Filtros compartidos */}
        <SubHeaderItem>
          <span style={{ fontWeight: 500 }}>Vehículo:</span>
          <SelectItem
            allowClear
            placeholder="Seleccionar vehículo"
            style={{ width: 220 }}
            loading={this.state.loadingVehiculos}
            value={vehiculoId}
            onChange={(value, option) => {
              const vehiculoSeleccionado = value
                ? this.state.todosVehiculos.find((v) => v._id.toString() === value.toString()) || null
                : null;
              this.setState({
                vehiculoId: value,
                vehiculoNombre: option ? option.children : "",
                vehiculoSeleccionado,
                ventas: [],
                facturas: [],
                selectedVentasKeys: [],
                selectedFacturasKeys: [],
                cargas: [],
              });
            }}
          >
            {this.state.todosVehiculos.map((v) => (
              <Select.Option key={v._id} value={v._id}>
                {v.nombre}
              </Select.Option>
            ))}
          </SelectItem>
          <span style={{ fontWeight: 500 }}>Período:</span>
          <RangePickerItem
            value={this.state.fechas}
            onChange={(fechas) => this.setState({ fechas })}
            style={{ width: 240 }}
          />
          {modo === "automatico" && (
            <>
              <span style={{ fontWeight: 500 }}>Combustible:</span>
              <SelectItem
                allowClear
                placeholder="Seleccionar insumo (gasolina, diesel...)"
                style={{ width: 300 }}
                loading={this.state.loadingInsumos}
                value={this.state.insumoId}
                onChange={(value, option) =>
                  this.setState({
                    insumoId: value,
                    insumoNombre: option ? option.children : "",
                  })
                }
              >
                {this.state.todosInsumos.map((i) => (
                  <Select.Option key={i._id} value={i._id}>
                    {i.stringBuscar || i.descripcion}
                  </Select.Option>
                ))}
              </SelectItem>
              <ButtonItem
                type="primary"
                loading={this.state.loading}
                onClick={this.consultarRendimiento.bind(this)}
              >
                Consultar
              </ButtonItem>
            </>
          )}
          {modo === "manual" && (
            <ButtonItem
              type="primary"
              loading={this.state.loadingCargas}
              onClick={this.cargarCargas.bind(this)}
            >
              Consultar
            </ButtonItem>
          )}
        </SubHeaderItem>

        {/* Info del vehículo seleccionado */}
        {this.state.vehiculoSeleccionado && (() => {
          const v = this.state.vehiculoSeleccionado;
          const titulo = [v.marca, v.modelo].filter(Boolean).join(" ") || vehiculoNombre;
          const detalles = [
            v.pesoBrutoV && { label: "Peso Bruto", val: `${v.pesoBrutoV} kg` },
            v.permisoSCT && { label: "Permiso SCT", val: v.permisoSCT },
            v.primaSeguro && { label: "Prima", val: v.primaSeguro },
            v.aseguradoraRespCivil && { label: "Seg. RC", val: `${v.aseguradoraRespCivil}${v.polizaRespCivil ? ` · ${v.polizaRespCivil}` : ""}` },
            v.aseguradoraCarga && { label: "Seg. Carga", val: `${v.aseguradoraCarga}${v.polizaCarga ? ` · ${v.polizaCarga}` : ""}` },
            v.aseguradoraMedAmbiente && { label: "Seg. MA", val: `${v.aseguradoraMedAmbiente}${v.polizaMedAmbiente ? ` · ${v.polizaMedAmbiente}` : ""}` },
          ].filter(Boolean);
          return (
            <Card
              size="small"
              style={{ marginTop: -5, marginBottom: 10, borderRadius: 6, borderLeft: "3px solid #00BFD6", background: "#f6fefe" }}
              bodyStyle={{ padding: "6px 14px" }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <CarOutlined style={{ fontSize: 16, color: "#00BFD6" }} />
                <span style={{ fontWeight: 700, fontSize: 13, color: "#00BFD6" }}>{titulo}</span>
                {v.anoModelo && <Tag color="#00BFD6" style={{ margin: 0 }}>{v.anoModelo}</Tag>}
                {v.placas && (
                  <Tag style={{ margin: 0, fontFamily: "monospace", fontWeight: 700, letterSpacing: 1, background: "#e6feff", borderColor: "#00BFD6", color: "#006d7a" }}>
                    {v.placas}
                  </Tag>
                )}
                {v.descripcion && <span style={{ fontSize: 11, color: "#8c8c8c" }}>— {v.descripcion}</span>}
                {detalles.length > 0 && (
                  <span style={{ color: "#d9d9d9", margin: "0 2px" }}>|</span>
                )}
                {detalles.map((d, i) => (
                  <span key={d.label} style={{ fontSize: 11 }}>
                    <span style={{ color: "#8c8c8c" }}>{d.label}: </span>
                    <span style={{ fontWeight: 600, color: "#262626" }}>{d.val}</span>
                    {i < detalles.length - 1 && <span style={{ color: "#d9d9d9", margin: "0 6px" }}>·</span>}
                  </span>
                ))}
              </div>
            </Card>
          );
        })()}

        <div
          style={{
            backgroundColor: "white",
            border: "1px solid rgb(235, 237, 240)",
            borderRadius: 8,
            padding: "10px 12px",
            marginBottom: 10,
          }}
        >
          <TabbedDynamicTable
            defaultActiveKey="manual"
            onTabChange={(key) => {
              this.setState({ modo: key });
              if (key === "manual" && this.state.vehiculoId && this.state.cargas.length === 0) {
                this.cargarCargas();
              }
            }}
            tabs={[
              {
                key: "manual",
                label: "Manual (cargas)",
                customContent: this.renderManual(
                  statCards,
                  statsCargas,
                  hayCargas,
                  dataRendimientoCargas,
                  cargasComputadas,
                  columnsCargas
                ),
              },
              {
                key: "automatico",
                label: "Automático (ventas)",
                customContent: this.renderAutomatico(stats, hayDatos, columnsVentas, columnsFacturas),
              },
            ]}
          />
        </div>

        <ModalCargaCombustible
          visible={this.state.modalCarga}
          carga={this.state.cargaEditando}
          vehiculoId={this.state.vehiculoId}
          onClose={(didSave) => this.cerrarModalCarga(didSave)}
        />

        <MandarCorreoCargaCombustible
          visible={this.state.modalCorreoCarga}
          carga={this.state.cargaCorreo}
          empresa={this.state.empresa}
          vehiculoNombre={this.state.vehiculoNombre}
          cerrar={() => this.setState({ modalCorreoCarga: false, cargaCorreo: null })}
        />

        <ModalReportesCargas
          visible={this.state.modalReportes}
          todosVehiculos={this.state.todosVehiculos}
          cerrar={() => this.setState({ modalReportes: false })}
        />
      </>
    );
  }

  renderAutomatico(stats, hayDatos, columnsVentas, columnsFacturas) {
    return (
      <>
        {/* Estadísticas */}
        {hayDatos && this.state.mostrarGraficas && (
          <Row gutter={[12, 12]} style={{ marginBottom: 10 }} align="stretch">
            {[
              { title: "KM / Litro", value: stats.kmPorLitro.toFixed(3), suffix: "km/L", color: "#1890ff" },
              { title: "Costo por KM", value: `$${stats.costoPorKm.toFixed(2)}`, suffix: "/km", color: "#52c41a" },
              { title: "Total Litros", value: stats.totalLitros.toFixed(3), suffix: "L", color: "#fa8c16" },
              { title: "Gasto Total Combustible", value: dineroDisabledMask(stats.gastoTotal), suffix: "", color: "#f5222d" },
              { title: "Total KM Recorridos", value: stats.totalKm.toFixed(2), suffix: "km", color: "#722ed1" },
            ].map(({ title, value, suffix, color }) => (
              <Col flex="1" key={title} style={{ display: "flex", minWidth: 140 }}>
                <Card
                  bordered
                  style={{ textAlign: "center", borderTop: `3px solid ${color}`, borderRadius: 8, flex: 1 }}
                  bodyStyle={{ padding: "14px 10px", display: "flex", alignItems: "center", justifyContent: "center" }}
                >
                  <Statistic
                    title={<span style={{ fontSize: 11 }}>{title}</span>}
                    value={value}
                    suffix={suffix}
                    valueStyle={{ fontSize: 20, fontWeight: "bold", color }}
                  />
                </Card>
              </Col>
            ))}
          </Row>
        )}

        {/* Gráficas */}
        {hayDatos && this.state.mostrarGraficas && (
          <Row gutter={[12, 12]} style={{ marginBottom: 10 }}>
            <Col xs={24} lg={12}>
              <Card
                title="Gasto de Combustible por Día"
                size="small"
                style={{ borderRadius: 8, borderTop: "3px solid #fa8c16" }}
                bodyStyle={{ height: 260, padding: "8px 4px 8px 4px" }}
              >
                {this.state.dataGraficoGasto[0]?.data?.length > 0 ? (
                  <ResponsiveLine
                    data={this.state.dataGraficoGasto}
                    margin={{ top: 10, right: 20, bottom: 65, left: 90 }}
                    xScale={{ type: "point" }}
                    yScale={{ type: "linear", min: 0, max: "auto" }}
                    yFormat={(v) => dineroDisabledMask(v)}
                    curve="monotoneX"
                    enableSlices="x"
                    colors={["#49ff25"]}
                    axisBottom={{ tickRotation: -45, legend: "Fecha", legendOffset: 58, legendPosition: "middle" }}
                    axisLeft={{ legend: "$ MXN", legendOffset: -78, legendPosition: "middle" }}
                    lineWidth={2}
                    pointSize={6}
                    pointBorderWidth={1}
                    pointColor={{ theme: "background" }}
                    pointBorderColor={{ from: "serieColor" }}
                  />
                ) : (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", color: "#bbb" }}>
                    Sin datos de facturas
                  </div>
                )}
              </Card>
            </Col>
            <Col xs={24} lg={12}>
              <Card
                title="KM Recorridos por Día"
                size="small"
                style={{ borderRadius: 8, borderTop: "3px solid #1890ff" }}
                bodyStyle={{ height: 260, padding: "8px 4px 8px 4px" }}
              >
                {this.state.dataGraficoKm[0]?.data?.length > 0 ? (
                  <ResponsiveLine
                    data={this.state.dataGraficoKm}
                    margin={{ top: 10, right: 20, bottom: 65, left: 80 }}
                    xScale={{ type: "point" }}
                    yScale={{ type: "linear", min: 0, max: "auto" }}
                    yFormat={(v) => `${(+v).toFixed(1)} km`}
                    curve="monotoneX"
                    enableSlices="x"
                    colors={["#1890ff"]}
                    axisBottom={{ tickRotation: -45, legend: "Fecha", legendOffset: 58, legendPosition: "middle" }}
                    axisLeft={{ legend: "KM", legendOffset: -65, legendPosition: "middle" }}
                    lineWidth={2}
                    pointSize={6}
                    pointBorderWidth={1}
                    pointColor={{ theme: "background" }}
                    pointBorderColor={{ from: "serieColor" }}
                  />
                ) : (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", color: "#bbb" }}>
                    Sin datos de viajes
                  </div>
                )}
              </Card>
            </Col>
          </Row>
        )}

        {/* Gráfica rendimiento km/L */}
        {hayDatos && this.state.mostrarGraficas && this.state.dataRendimiento.length > 0 && (
          <Row gutter={[12, 12]} style={{ marginBottom: 10 }}>
            <Col xs={24}>
              <Card
                title={`Rendimiento km/L por Carga — Promedio: ${this.state.avgRendimiento.toFixed(3)} km/L`}
                size="small"
                style={{ borderRadius: 8, borderTop: "3px solid #722ed1" }}
                bodyStyle={{ height: 280, padding: "8px 4px 8px 4px" }}
              >
                <ResponsiveBar
                  data={this.state.dataRendimiento}
                  keys={["rendimiento"]}
                  indexBy="fecha"
                  margin={{ top: 20, right: 30, bottom: 65, left: 70 }}
                  padding={0.35}
                  colors={({ data }) => data.color}
                  label={({ value }) => value.toFixed(2)}
                  labelSkipWidth={12}
                  labelSkipHeight={12}
                  labelTextColor="#ffffff"
                  layers={["grid", "axes", "bars", "markers", "legends", "annotations"]}
                  markers={[
                    {
                      axis: "y",
                      value: this.state.avgRendimiento,
                      lineStyle: { stroke: "#722ed1", strokeWidth: 2, strokeDasharray: "6 3" },
                      legend: `Prom. ${this.state.avgRendimiento.toFixed(2)} km/L`,
                      legendPosition: "top-right",
                      textStyle: { fill: "#722ed1", fontSize: 11, fontWeight: "bold" },
                    },
                  ]}
                  axisBottom={{ tickRotation: -45, legend: "Fecha de carga", legendOffset: 55, legendPosition: "middle" }}
                  axisLeft={{ legend: "km / Litro", legendOffset: -58, legendPosition: "middle", format: (v) => v.toFixed(1) }}
                  tooltip={({ data }) => (
                    <div style={{ background: "white", padding: "6px 10px", border: "1px solid #d9d9d9", borderRadius: 4, fontSize: 12 }}>
                      <strong>{data.fecha}</strong>
                      <br />
                      Rendimiento: <strong>{data.rendimiento} km/L</strong>
                      <br />
                      KM: {(data.kmEnPeriodo || 0).toFixed(1)} — Litros: {(data.liters || 0).toFixed(3)}
                    </div>
                  )}
                />
              </Card>
            </Col>
          </Row>
        )}

        {/* Tabla de viajes */}
        <div style={{ backgroundColor: "white", borderRadius: 8, padding: "12px 0", marginBottom: 10 }}>
          <p style={{ fontWeight: 600, marginBottom: 8, fontSize: 14 }}>
            Viajes Registrados
            {this.state.ventas.length > 0 && (
              <span style={{ fontWeight: 400, fontSize: 12, color: "#888", marginLeft: 8 }}>
                ({this.state.selectedVentasKeys.length} de {this.state.ventas.length} seleccionados)
              </span>
            )}
          </p>
          <TableItem
            rowSelection={{
              selectedRowKeys: this.state.selectedVentasKeys,
              onChange: (keys) => this.setState({ selectedVentasKeys: keys }),
            }}
            rowKey={(r) => r.rowKey}
            size="small"
            loading={this.state.loading}
            dataSource={this.state.ventas}
            columns={columnsVentas}
            locale={{ emptyText: "No se encontraron viajes para este período" }}
          />
        </div>

        {/* Tabla de facturas de combustible */}
        <div style={{ backgroundColor: "white", borderRadius: 8, padding: "12px 0", marginBottom: 10 }}>
          <p style={{ fontWeight: 600, marginBottom: 8, fontSize: 14 }}>
            Facturas de Combustible
            {this.state.facturas.length > 0 && (
              <span style={{ fontWeight: 400, fontSize: 12, color: "#888", marginLeft: 8 }}>
                ({this.state.selectedFacturasKeys.length} de {this.state.facturas.length} seleccionadas)
              </span>
            )}
          </p>
          <TableItem
            rowSelection={{
              selectedRowKeys: this.state.selectedFacturasKeys,
              onChange: (keys) => this.setState({ selectedFacturasKeys: keys }),
            }}
            rowKey={(r) => r._id.toString()}
            size="small"
            loading={this.state.loading}
            dataSource={this.state.facturas}
            columns={columnsFacturas}
            locale={{ emptyText: "No se encontraron facturas de combustible para este período" }}
          />
        </div>
      </>
    );
  }

  renderManual(statCards, statsCargas, hayCargas, dataRendimientoCargas, cargasComputadas, columnsCargas) {
    const dataRendimientoChofer = resumenPorChoferUtil(cargasComputadas).map((d) => ({
      ...d,
      color: d.rendimiento >= statsCargas.kmPorLitro ? "#52c41a" : "#f5222d",
    }));
    return (
      <>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0" }}>
          <span style={{ fontWeight: 600, fontSize: 14 }}>
            Cargas Registradas
            {cargasComputadas.length > 0 && (
              <span style={{ fontWeight: 400, fontSize: 12, color: "#888", marginLeft: 8 }}>
                ({cargasComputadas.length})
              </span>
            )}
          </span>
          <div style={{ display: "flex", gap: 8 }}>
            {this.props.permisoReportesCargas && (
              <ButtonItem
                morado
                icon={<FilePdfOutlined />}
                onClick={() => this.setState({ modalReportes: true })}
              >
                Reportes generales
              </ButtonItem>
            )}
            {this.props.permisoAgregarCarga && (
              <ButtonItem
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => this.abrirModalCarga(null)}
              >
                Agregar carga
              </ButtonItem>
            )}
          </div>
        </div>

        {hayCargas && (
          <Row gutter={[12, 12]} style={{ marginBottom: 10 }} align="stretch">
            {statCards.map(({ title, value, suffix, color }) => (
              <Col flex="1" key={title} style={{ display: "flex", minWidth: 140 }}>
                <Card
                  bordered
                  style={{ textAlign: "center", borderTop: `3px solid ${color}`, borderRadius: 8, flex: 1 }}
                  bodyStyle={{ padding: "14px 10px", display: "flex", alignItems: "center", justifyContent: "center" }}
                >
                  <Statistic
                    title={<span style={{ fontSize: 11 }}>{title}</span>}
                    value={value}
                    suffix={suffix}
                    valueStyle={{ fontSize: 20, fontWeight: "bold", color }}
                  />
                </Card>
              </Col>
            ))}
          </Row>
        )}

        {hayCargas && dataRendimientoCargas.length > 0 && (
          <Row gutter={[12, 12]} style={{ marginBottom: 10 }}>
            <Col xs={24}>
              <Card
                title={`Rendimiento km/L por Carga — Promedio: ${statsCargas.avgRendimiento.toFixed(3)} km/L`}
                size="small"
                style={{ borderRadius: 8, borderTop: "3px solid #722ed1" }}
                bodyStyle={{ height: 280, padding: "8px 4px 8px 4px" }}
              >
                <ResponsiveBar
                  data={dataRendimientoCargas}
                  keys={["rendimiento"]}
                  indexBy="fecha"
                  margin={{ top: 20, right: 30, bottom: 70, left: 70 }}
                  padding={0.35}
                  colors={({ data }) => data.color}
                  label={({ value }) => value.toFixed(2)}
                  labelSkipWidth={12}
                  labelSkipHeight={12}
                  labelTextColor="#ffffff"
                  layers={["grid", "axes", "bars", "markers", "legends", "annotations"]}
                  markers={[
                    {
                      axis: "y",
                      value: statsCargas.avgRendimiento,
                      lineStyle: { stroke: "#722ed1", strokeWidth: 2, strokeDasharray: "6 3" },
                      legend: `Prom. ${statsCargas.avgRendimiento.toFixed(2)} km/L`,
                      legendPosition: "top-right",
                      textStyle: { fill: "#722ed1", fontSize: 11, fontWeight: "bold" },
                    },
                  ]}
                  axisBottom={{ tickRotation: -45, legend: "KM Odómetro", legendOffset: 60, legendPosition: "middle" }}
                  axisLeft={{ legend: "km / Litro", legendOffset: -58, legendPosition: "middle", format: (v) => v.toFixed(1) }}
                  tooltip={({ data }) => (
                    <div style={{ background: "white", padding: "6px 10px", border: "1px solid #d9d9d9", borderRadius: 4, fontSize: 12 }}>
                      <strong>Odómetro {data.fecha}</strong>
                      <br />
                      Rendimiento: <strong>{data.rendimiento} km/L</strong>
                      <br />
                      KM: {(data.kmEnPeriodo || 0).toFixed(1)} — Litros: {(data.liters || 0).toFixed(3)}
                    </div>
                  )}
                />
              </Card>
            </Col>
          </Row>
        )}

        {hayCargas && dataRendimientoChofer.length > 0 && (
          <Row gutter={[12, 12]} style={{ marginBottom: 10 }}>
            <Col xs={24}>
              <Card
                title="Rendimiento km/L por Chofer"
                size="small"
                style={{ borderRadius: 8, borderTop: "3px solid #00BFD6" }}
                bodyStyle={{ height: 280, padding: "8px 4px 8px 4px" }}
              >
                <ResponsiveBar
                  data={dataRendimientoChofer}
                  keys={["rendimiento"]}
                  indexBy="chofer"
                  margin={{ top: 20, right: 30, bottom: 90, left: 70 }}
                  padding={0.4}
                  colors={({ data }) => data.color}
                  label={({ value }) => value.toFixed(2)}
                  labelSkipWidth={12}
                  labelSkipHeight={12}
                  labelTextColor="#ffffff"
                  layers={["grid", "axes", "bars", "markers", "legends", "annotations"]}
                  markers={[
                    {
                      axis: "y",
                      value: statsCargas.kmPorLitro,
                      lineStyle: { stroke: "#722ed1", strokeWidth: 2, strokeDasharray: "6 3" },
                      legend: `Prom. general ${statsCargas.kmPorLitro.toFixed(2)} km/L`,
                      legendPosition: "top-right",
                      textStyle: { fill: "#722ed1", fontSize: 11, fontWeight: "bold" },
                    },
                  ]}
                  axisBottom={{ tickRotation: -35, legend: "Chofer", legendOffset: 80, legendPosition: "middle" }}
                  axisLeft={{ legend: "km / Litro", legendOffset: -58, legendPosition: "middle", format: (v) => v.toFixed(1) }}
                  tooltip={({ data }) => (
                    <div style={{ background: "white", padding: "6px 10px", border: "1px solid #d9d9d9", borderRadius: 4, fontSize: 12 }}>
                      <strong>{data.chofer}</strong>
                      <br />
                      Rendimiento: <strong>{data.rendimiento} km/L</strong>
                      <br />
                      KM: {(data.km || 0).toFixed(1)} — Litros: {(data.litros || 0).toFixed(3)}
                    </div>
                  )}
                />
              </Card>
            </Col>
          </Row>
        )}

        <div style={{ backgroundColor: "white", borderRadius: 8, padding: "12px 0" }}>
          <TableItem
            rowKey={(r) => r._id.toString()}
            size="small"
            loading={this.state.loadingCargas}
            dataSource={cargasComputadas}
            columns={columnsCargas}
            locale={{ emptyText: "No hay cargas registradas. Agrega la primera con el botón de arriba." }}
          />
        </div>
      </>
    );
  }

}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoAgregarCarga:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (p) => p.permisoId.toString() === "6a5babb0b7bbf389e1b55bb1"
    )?.activado,
  permisoEditarCarga:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (p) => p.permisoId.toString() === "6a5babbfb7bbf389e1b55bb6"
    )?.activado,
  permisoEliminarCarga:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (p) => p.permisoId.toString() === "6a5babd6b7bbf389e1b55bd0"
    )?.activado,
  permisoReportesCargas:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (p) => p.permisoId.toString() === "6a5babe9b7bbf389e1b55bfc"
    )?.activado,
});

export default connect(mapStateToProps)(ConsumoCombustible);
